window["engagement-finder"] =  window['engagement-finder']  ||  {}
export default {
  name: "RejectedByComPage",
  components: {
    ...window["engagement-finder"].default
  },
  data: () => ({
    language: "fr"
  })
};